import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    clubTypesList: null,
    clubTypesListLoading: false
};

export const clubTypesAction = createAsyncThunk(
  'clubTypesAction',
  async (payload, { dispatch }) => {
    dispatch(setClubTypesListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/clubTypes';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setClubTypesListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Тип клуба успешно отредактирован`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Тип клуба успешно добавлен`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Тип клуба успешно удален`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setClubTypesListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const ClubTypesSlice = createSlice({
    name: 'clubTypes',
    initialState,
    reducers: {
        setClubTypesListLoading: (state, action) => {
            state.clubTypesListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(clubTypesAction.fulfilled, (state, action) => {
            state.clubTypesList = action.payload
        })
    }
});

export const { setClubTypesListLoading } = ClubTypesSlice.actions;

export default ClubTypesSlice.reducer